import { withInstall } from '@zoryn/utils'
import Mention from './src/mention.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZMention: SFCWithInstall<typeof Mention> = withInstall(Mention)
export default ZMention

export * from './src/mention'
